<template>
    <v-container fluid>
        <v-toolbar color="secondary" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Payroll View</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon left to="/administration/payroll"
                ><v-icon>mdi-arrow-left</v-icon></v-btn
            >
        </v-toolbar>
        <v-card>
            <v-container fluid>
                <v-row class="justify-center">
                    <v-col cols="8">
                        <v-text-field
                            placeholder="Search"
                            type="text"
                            hide-details
                            number
                            v-model="searchpay"
                            v-on:keyup.enter="searchPayroll()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="dmiRow">
                    <v-col cols="12">
                        <v-simple-table dense class="dmiTable">
                            <thead>
                                <tr>
                                    <th>Pay St</th>
                                    <th>Driver Pay</th>
                                    <th>PayDate</th>
                                    <th>Shift</th>
                                    <th>Shift Details</th>
                                    <th>Driver</th>
                                    <th>Truck</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ totals[0].PayStId }}
                                    </td>
                                    <td>
                                        {{ totals[0].OrderTotal }}
                                    </td>
                                    <td>
                                        {{ totals[0].PayDate }}
                                    </td>
                                    <td>
                                        {{
                                            payrolldata[idx] === undefined
                                                ? ''
                                                : payrolldata[idx]['Shift']
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            payrolldata[idx] === undefined
                                                ? ''
                                                : payrolldata[idx][
                                                      'ShiftDetail'
                                                  ]
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            payrolldata[idx] === undefined
                                                ? ''
                                                : payrolldata[idx]['Driver']
                                        }}
                                    </td>
                                    <td>
                                        {{ totals[0].Truck }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-data-iterator
                        :items="filteredItems"
                        :page="page"
                        style="width: 100%;"
                        hide-default-footer
                        :items-per-page="1"
                    >
                        <template v-slot:header>
                            <v-toolbar dense color="primary" class="my-1 py-4">
                                <template v-if="$vuetify.breakpoint.mdAndUp">
                                    <v-combobox
                                        dark
                                        dense
                                        label="Order Look Up"
                                        :items="payrolldata"
                                        :item-text="'OrderID'"
                                        v-model="cbx"
                                        @change="changeOrder"
                                        clearable
                                        append-icon="mdi-magnify"
                                    >
                                    </v-combobox>
                                    <v-spacer></v-spacer>
                                    <v-spacer></v-spacer>

                                    <v-btn
                                        color="light"
                                        class="mb-6 mr-2"
                                        @click="openModalOrder(cbx.OrderID)"
                                    >
                                        View Order
                                        <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                </template>
                            </v-toolbar>
                        </template>
                        <template v-slot:default="props">
                            <v-container grid-list-xs fluid>
                                <v-row
                                    v-for="(item, i) in props.items"
                                    :key="i"
                                >
                                    <v-simple-table
                                        dense
                                        style="width: 100%;"
                                        height="500px"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Order</th>
                                                <th>BOL</th>
                                                <th>Date</th>
                                                <th>Transaction Type</th>
                                                <th>Terminal</th>
                                                <th>Station</th>
                                                <th>City</th>
                                                <th>Kms</th>
                                                <th>ShiftDetail</th>
                                                <th>PayId</th>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm,
                                                j) in item.transactions"
                                            >
                                                <tr :key="'tran' + j">
                                                    <td>
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td>{{ item.BOL }}</td>
                                                    <td>{{ item.Date }}</td>
                                                    <td>
                                                        {{
                                                            itm.tran_type
                                                                .TranType
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            item.terminal
                                                                .TerminalName
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ item.station.Name }}
                                                    </td>
                                                    <td>
                                                        {{ item.station.City }}
                                                    </td>
                                                    <td>{{ item.Kms }}</td>
                                                    <td>
                                                        {{ item.ShiftDetail }}
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                            dense
                                                            style="width:50px;"
                                                            v-model="itm.PayId"
                                                            hide-details
                                                        ></v-text-field>
                                                    </td>
                                                    <td
                                                        v-if="
                                                            itm.order_details ==
                                                                null
                                                        "
                                                    ></td>
                                                    <td v-else>
                                                        {{
                                                            itm.order_details
                                                                .product.Product
                                                        }}
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                            style="width:50px;"
                                                            dense
                                                            @blur="
                                                                CalculateAmount(
                                                                    itm
                                                                )
                                                            "
                                                            v-model="
                                                                itm.Quantity
                                                            "
                                                            hide-details
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                            style="width:50px;"
                                                            @blur="
                                                                CalculateAmount(
                                                                    itm
                                                                )
                                                            "
                                                            dense
                                                            v-model="itm.Rate"
                                                            hide-details
                                                        ></v-text-field>
                                                    </td>
                                                    <td>
                                                        <v-text-field
                                                            style="width:50px;"
                                                            dense
                                                            v-model="itm.Amount"
                                                            hide-details
                                                        ></v-text-field>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-btn
                                                            color="red"
                                                            style="float:right;"
                                                            icon
                                                            small
                                                            @click="
                                                                dltTrnsConfirm(
                                                                    itm
                                                                )
                                                            "
                                                            ><v-icon
                                                                >mdi-delete</v-icon
                                                            ></v-btn
                                                        >

                                                        <v-btn
                                                            color="primary"
                                                            style="float:right;"
                                                            icon
                                                            small
                                                            @click="
                                                                openRates(itm)
                                                            "
                                                            ><v-icon
                                                                >mdi-book-open-blank-variant</v-icon
                                                            ></v-btn
                                                        >
                                                        <v-btn
                                                            color="success"
                                                            style="float:right;"
                                                            icon
                                                            small
                                                            @click="
                                                                saveTrnsaction(
                                                                    itm,
                                                                    j,
                                                                    item
                                                                )
                                                            "
                                                            ><v-icon
                                                                >mdi-content-save</v-icon
                                                            ></v-btn
                                                        >
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </v-simple-table>
                                </v-row>
                            </v-container>
                        </template>
                        <template v-slot:footer>
                            <v-row class="mt-2">
                                <v-simple-table dense class="dmiTable mx-3">
                                    <thead>
                                        <tr>
                                            <th>Order Total</th>
                                            <th>FSC</th>
                                            <th>FSC Amount</th>
                                            <th>Subtotal</th>
                                            <th>HST / GST</th>
                                            <th v-if="totals[0].TVQ">TSP</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                $
                                                {{ totals[0].OrderTotal }}
                                            </td>
                                            <td style="height: 0px">
                                                {{ totals[0].FSC }}
                                            </td>
                                            <td>
                                                $
                                                {{ totals[0].FSCAmount }}
                                            </td>
                                            <td>
                                                $
                                                {{ totals[0].SubTotal }}
                                            </td>
                                            <td>
                                                $
                                                {{ totals[0].HST }}
                                            </td>
                                            <td v-if="totals[0].TVQ">
                                                $
                                                {{ totals[0].TVQ }}
                                            </td>
                                            <td>
                                                $
                                                {{ totals[0].Total }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <v-col>
                                    <v-row>
                                        <v-btn
                                            color="primary "
                                            small
                                            height="50px"
                                            dark
                                            @click="calculatePayroll(1)"
                                            v-if="totals[0].PayStTypeID < 3"
                                            >Calculate<br />Totals</v-btn
                                        >

                                        <v-btn
                                            color="primary "
                                            small
                                            height="50px"
                                            dark
                                            @click="calculate"
                                            v-else
                                            >Calculate<br />Totals</v-btn
                                        >
                                        <v-btn
                                            color="primary"
                                            class="mx-4"
                                            small
                                            height="50px"
                                            dark
                                            @click="downloadPDF"
                                            ><v-icon class="mr-2"
                                                >mdi-cloud-download</v-icon
                                            >
                                            Download PDF</v-btn
                                        >
                                        <v-btn
                                            color="primary"
                                            class="mr-4"
                                            small
                                            height="50px"
                                            dark
                                            @click="downloadExcel"
                                            ><v-icon class="mr-2"
                                                >mdi-file-excel</v-icon
                                            >
                                            Download Excel</v-btn
                                        >
                                        <v-btn
                                            color="red"
                                            small
                                            height="50px"
                                            dark
                                            @click="dltPayrollConfirm"
                                            ><v-icon>mdi-delete</v-icon>
                                            Delete</v-btn
                                        >
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row justify="end">
                                <v-spacer></v-spacer>
                                <span class="mr-5 mb-6 pr-4">
                                    Page {{ page }} of
                                    {{ payrolldata.length }}
                                </span>
                                <v-btn
                                    fab
                                    dark
                                    color="primary"
                                    class="mr-1"
                                    x-small
                                    @click="formerPage"
                                >
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-btn
                                    fab
                                    dark
                                    color="primary"
                                    class="ml-1 mr-5"
                                    @click="nextPage"
                                    x-small
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-row>
                        </template>
                    </v-data-iterator>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog
            v-model="$store.state.transacting.dialogRate"
            persistent
            :overlay="false"
            width="1300px"
            transition="dialog-transition"
        >
            <ratesModal
                :dataInfo="rateInfo"
                v-if="$store.state.transacting.dialogRate"
            ></ratesModal>
        </v-dialog>
        <v-dialog
            v-model="$store.state.posting.dialog"
            transition="dialog-bottom-transition"
            overlay-color="accent"
            width="1500"
        >
            <OrderData :isModal="true" v-if="$store.state.posting.dialog" />
        </v-dialog>

        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import ratesModal from '../Modals/Administration/Transacting/RatesModal.vue';
import OrderData from './../Modals/Administration/OrderData.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import moment from 'moment';
import axios from 'axios';
export default {
    directives: { mask },
    components: { ratesModal, OrderData, ConfirmDialogue },
    data: function() {
        return {
            dlPrms: [],
            searchpay: '',
            headers: [{ text: 'Order', value: 'OrderID', width: '1%' }],
            key: [
                { text: 'Order', value: 'order[OrderID]', width: '1%' },
                { text: 'BOL', value: 'order[BOL]', width: '1%' },
                { text: 'Date', value: 'Date', width: '1%' },
                {
                    text: 'Transaction Type',
                    value: 'tran_type[TranType]',
                    width: '15%'
                },
                {
                    text: 'Terminal',
                    value: 'order[terminal][TerminalName]',
                    width: '15%'
                },
                {
                    text: 'Station',
                    value: 'order[station][Name]',
                    width: '20%'
                },
                { text: 'City', value: 'order[station][City]', width: '5%' },
                { text: 'KMs', value: 'order[Kms]', width: '5%' },
                {
                    text: 'Product',
                    value: 'order_details[product][Product]',
                    width: '5%'
                },
                { text: 'Quantity', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '5%' },
                { text: 'Actions', value: 'actions', width: '10%' }
            ],
            payrolldata: [],
            dataOrders: [],
            orders: [],
            ordersNum: [],
            group: [],
            Shifts: [],
            dialog: true,
            idx: 0,
            gst: 0,
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            itemsPerPageArray: [4, 8, 12],
            search: '',
            filter: {},
            sortDesc: false,
            page: 1,
            ct: 0,
            cbx: '',
            itemsPerPage: 4,
            sortBy: 'name',
            totals: [
                {
                    OrderTotal: '',
                    FSC: '',
                    FSCAmount: '',
                    SubTotal: '',
                    HST: '',
                    Total: '',
                    TVQ: ''
                }
            ]
        };
    },
    computed: {
        filteredKeys() {
            return this.keys.filter(key => key !== 'Name');
        },
        filteredItems() {
            return this.payrolldata.filter(i => {
                return !this.cbx || i.OrderID == this.cbx.OrderID;
            });
        }
    },
    mounted() {
        this.chargePayroll();
    },
    watch: {
        '$store.state.regularPayroll.watch': function() {
            if (this.$store.state.regularPayroll.watch == true) {
                this.payrolldata = [];
                this.dataOrders = [];
                this.ordersNum = [];
                this.idx = 0;
                this.page = 1;
                this.chargePayroll();
                this.$store.state.regularPayroll.watch = false;
            }
        }
    },
    methods: {
        changeOrder: async function() {
            console.log(this.cbx, this.payrolldata);
            this.idx = await this.payrolldata.findIndex(x => {
                return x.OrderID == this.cbx.OrderID;
            });
            console.log(this.idx, this.page);
            this.page = this.idx + 1;
            this.page;
        },
        downloadPDF: function() {
            var str = this.$store;
            axios
                .get('payroll/print/' + this.$store.state.payroll.searchInv, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        this.$store.state.payroll.searchInv +
                            ' - ' +
                            this.totals[0].Truck +
                            ' - ' +
                            moment(this.totals[0].PayDate).format('ll') +
                            '.pdf'
                    );
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        downloadExcel: function() {
            var str = this.$store;
            axios
                .get('payroll/excel/' + this.$store.state.payroll.searchInv, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'payST_' + this.$store.state.payroll.searchInv + '.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteTrnsaction: function(itm) {
            var str = this.$store;
            axios
                .delete('transaction/removePay/' + itm, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete transaction successful.'
                    });
                    this.$store.state.regularPayroll.watch = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        deletePayroll: function() {
            var str = this.$store;
            axios
                .delete('payroll/' + this.$store.state.payroll.searchInv, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete Payroll successful.'
                    });
                    this.$router.push('/administration/payroll');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        async dltTrnsConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this transaction',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteTrnsaction(itm.TranId);
            }
        },
        async dltPayrollConfirm() {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You are about to delete invoice #' +
                    this.$store.state.payroll.searchInv,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deletePayroll();
            }
        },
        async calculate() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You want to calculate totals with HST',
                // message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.calculatePayroll(1);
            } else {
                this.calculatePayroll(0);
            }
        },
        openModalOrder: function(item) {
            console.log(item);
            this.$store.state.orderInfo.orderId = item;
            this.$store.state.posting.dialog = true;
        },
        openRates: function(itm) {
            this.rateInfo = itm;
            this.$store.state.transacting.dialogRate = true;
        },
        calculatePayroll: function(status) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get(
                    // 'payroll/calculate/' + this.$store.state.payroll.searchInv+ '/'+ status,
                    'payroll/calculate/' +
                        this.$store.state.payroll.searchInv +
                        '/' +
                        status +
                        '/' +
                        this.gst, // Wait until Itzel returns
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    this.loadTotals();
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Recalculate successful'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        saveTrnsaction: function(itm, idx, item) {
            var str = this.$store;
            var params = {
                Quantity: itm.Quantity,
                Rate: itm.Rate,
                Amount: itm.Amount,
                PayId: itm.PayId
            };
            axios
                .put('transaction/' + itm.TranId, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    if (this.$store.state.payroll.searchInv == itm.PayId) {
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Save successfully'
                        });
                        if (this.totals[0].PayStTypeID == 3) {
                            this.calculatePayroll(0);
                        } else {
                            this.calculatePayroll(1);
                        }
                    } else {
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Save successfully and Change PayId'
                        });
                        item.transactions.splice(idx, 1);
                        // console.log(item.transactions.length);
                        // if(item.transactions.length == 1){
                        //     const indx = this.payrolldata.findIndex(x => {
                        //         x.OrderID = itm.OrderNumber;
                        //     });
                        //     console.log(indx);
                        //     item.transactions.splice(idx, 1);
                        //     this.payrolldata.splice(indx, 1);
                        // }else{
                        // }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        CalculateAmount: function(itm) {
            console.log(itm);
            let amount = 0;
            if (itm.TranType == 27 || itm.TranType == 20) {
                amount = ((itm.Quantity * itm.Rate) / 1000) * -1;
                console.log(amount);
                itm.Amount = Number(amount.toFixed(2));
            } else {
                amount = itm.Quantity * itm.Rate * -1;
                console.log(amount);
                itm.Amount = Number(amount.toFixed(2));
            }
        },
        chargePayroll: async function() {
            this.group = [];
            this.gst = 0;
            console.log(this.$store.state.payroll.searchInv);
            this.$store.state.isLoading = true;
            try {
                let response = await axios.get(
                    'transaction/payrollID/' +
                        this.$store.state.payroll.searchInv,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                );
                response.data.forEach(x => {
                    if (x.DriverID == 420) {
                        this.gst = 1;
                    }
                });
                this.payrolldata = response.data;
                console.log(this.payrolldata);
                await this.LoadShifts();
                await this.LoadTransaction();
                await this.loadTotals();
                this.cbx = this.payrolldata[this.idx];
                this.dialog = false;
                this.$store.state.isLoading = false;
            } catch (error) {
                this.$store.state.isLoading = false;
                console.log(error);
            }
        },
        searchPayroll: async function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            if (this.searchpay == '') {
                this.alert = true;
                this.alertMsg = 'Payroll number needed';
                this.$store.state.isLoading = false;
            } else {
                this.$store.state.payroll.dialog = true;
                try {
                    let response = await axios.get(
                        'payroll/' + this.searchpay,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    );
                    console.log(response);
                    if (response.data == '') {
                        this.searchpay = '';
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Payroll not found'
                        });
                    } else {
                        this.$store.state.payroll.searchInv = this.searchpay;
                        this.payrolldata = [];
                        this.dataOrders = [];
                        this.ordersNum = [];
                        this.chargePayroll();
                        this.$store.state.payroll.dialog = false;
                    }
                } catch (error) {
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Payroll not found'
                        });
                        this.searchpay = '';
                    }
                }
                this.$store.state.isLoading = false;
            }
        },
        loadTotals: function() {
            axios
                .get('payroll/' + this.$store.state.payroll.searchInv, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.totals = response.data;
                    console.log(this.totals);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        LoadShifts: async function() {
            var a = [];
            for (let i = 0; i < this.payrolldata.length; i++) {
                a.push(this.payrolldata[i].ShiftDetail);
            }
            this.Shifts = await a.filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            });
            this.Shifts.forEach(shift => {
                const orders = this.payrolldata.filter(ord => {
                    return ord.ShiftDetail == shift;
                });
                const value = this.getMaxLoadNum(orders, 'LoadNum');
                for (let i = 1; i <= value; i++) {
                    const ords = orders.filter(ord => {
                        return ord.LoadNum == i;
                    });
                    // this.group.push(ords.map(function(t) {
                    //     return t.transactions;
                    // }));
                    this.group.push(ords);
                }
            });
        },
        LoadTransaction: async function() {
            const grp = this.group.filter(group => {
                return group.length > 1;
            });
            // console.log(grp);
            var arr = [];
            var trans = [];
            var trns = [];
            var ords = [];
            var temp = [];
            for (let i = 0; i < grp.length; i++) {
                trans = [];
                ords = [];
                temp = [];
                trns = [];
                for (let j = 0; j < grp[i].length; j++) {
                    for (
                        let k = 0;
                        k < Object.keys(grp[i][j]['transactions']).length;
                        k++
                    ) {
                        trns.push(grp[i][j].transactions[k]);
                    }
                    //  console.log(trns)
                    trans.push(trns);
                    ords.push(grp[i][j].OrderID);
                }
                temp.push({ Orders: ords, transactions: trans });
                arr.push(temp);
            }
            //  console.log(arr);
            this.AssingSplitTransactions(arr);
        },
        AssingSplitTransactions: function(arr) {
            arr.forEach(ar => {
                ar.forEach(ords => {
                    // console.log(elm.Orders);
                    ords.Orders.forEach(ord => {
                        const idx = this.payrolldata.findIndex(data => {
                            return data.OrderID == ord;
                        });
                        // console.log( this.payrolldata[idx], ord)
                        this.payrolldata[idx].transactions =
                            ords.transactions[0];
                    });
                });
            });
        },
        getMaxLoadNum: function(objeto, propiedad) {
            if (objeto.length === 0) {
                return null; // Si el arreglo está vacío, no hay valor más alto que retornar
            }

            let valorMasAlto = objeto[0][propiedad]; // Asignamos el primer valor de la propiedad como el más alto inicialmente

            for (let i = 1; i < objeto.length; i++) {
                const valorActual = objeto[i][propiedad];
                if (valorActual > valorMasAlto) {
                    valorMasAlto = valorActual; // Actualizamos el valor más alto si encontramos uno mayor
                }
            }

            return valorMasAlto;
        },
        loadOrdersNumber() {
            var a = [];
            for (let i = 0; i < this.payrolldata.length; i++) {
                a.push(this.payrolldata[i].OrderNumber);
            }
            this.ordersNum = a.filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            });
            this.cbx = this.ordersNum[0];
            console.log(this.ordersNum);
        },
        loadOrders: async function() {
            for (let i = 0; i < this.ordersNum.length; i++) {
                const data = await this.payrolldata.filter(
                    x => x.OrderNumber === this.ordersNum[i]
                );
                await this.dataOrders.push(data);
            }
            console.log(this.dataOrders);
        },
        loadSplitOrder: async function() {
            var arr = [];
            for (let i = 0; i < this.ordersNum.length; i++) {
                const data = await this.dataOrders.filter(
                    x => x.OrderNumber === this.ordersNum[i]
                );
                +(await arr.push(data));
            }
        },
        nextPage() {
            if (this.page + 1 <= this.payrolldata.length) {
                this.page += 1;
                this.idx++;
                console.log(this.page, this.idx);
                this.cbx = this.payrolldata[this.idx];
            }
        },
        formerPage() {
            if (this.page - 1 >= 1) {
                this.page -= 1;
                this.idx--;
                console.log(this.page, this.idx);
                this.cbx = this.payrolldata[this.idx];
            }
        },
        updateItemsPerPage() {
            console.log(this.ordersNum.indexOf(this.cbx));
            this.page = this.ordersNum.indexOf(this.cbx) + 1;
            this.ct = this.ordersNum.indexOf(this.cbx);
        }
    }
};
</script>
<style scoped>
.dmiTable td {
    border-left: 1px solid #fff;
    background: #eee;
}
.dmiRow {
    background: #ebf3fd;
}
</style>
